export const SUPPLIER_COST = "supplier-costs" as const

export type SupplierCost = {
    id: string
    type: typeof SUPPLIER_COST
    attributes: {
        supplierId: string
        cost: string
        isDefault: boolean
        supplierName: string
    }
}

export type SupplierCostElastic = {
    id: string
    supplierId: string
    unitCost: string
}


// WEBPACK FOOTER //
// ./src/state/product/models/supplierCost.ts